import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white rounded-lg mr-4"
}
const _hoisted_3 = { class: "flex flex-row gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_MultipleSelect = _resolveComponent("MultipleSelect")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalDownloadListCargo = _resolveComponent("ModalDownloadListCargo")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `flex flex-row items-center justify-between w-full ${
        _ctx.isSuccessBookingTab ? 'pb-1' : 'pb-4'
      }`
    
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Search, {
        onInput: _ctx.onSearch,
        onClear: _ctx.onClearSearch,
        value: _ctx.searchValue,
        placeholder: _ctx.$t('No. Booking')
      }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
      (_ctx.isSuccessBookingTab)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.badgeSuccessFilterOptions, (filter, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index.toString(),
                  class: "cursor-pointer"
                }, [
                  _createVNode("div", {
                    class: ["w-full rounded-lg py-2.5 px-5 text-12px text-center whitespace-nowrap", 
                `${
                  _ctx.cargoTypes.includes(filter.value)
                    ? 'font-semibold bg-pink-lp-500 text-red-lp-100 border border-red-lp-100'
                    : 'font-semibold bg-white text-gray-lp-300 border border-gray-lp-1600'
                }`
              ],
                    onClick: () => _ctx.onFilterCargoType(filter)
                  }, _toDisplayString(filter.name) + " " + _toDisplayString(_ctx.filterCounter(filter.value)), 11, ["onClick"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_AdvancedFilter, {
        "model-value": _ctx.advancedFilterData,
        isCityDestination: "",
        isAirport: "",
        isHub: "",
        customPlaceholder: _ctx.$t('Pilih Tipe Kargo'),
        titleTypeCustom: _ctx.$t('Tipe Kargo'),
        customTitlePlaceholderCityDestination: _ctx.$t('Kota tujuan'),
        customTitlePlaceholderAirportCode: _ctx.$t('Kode bandara tujuan'),
        customTitlePlaceholderHubLocation: "Lokasi HUB",
        customTypeList: _ctx.typeList,
        isScroll: false,
        isDisabled: false,
        onChange: _cache[1] || (_cache[1] = (e) => _ctx.onChangeAdvancedFilter({ ...e, isSuccessBookingTab: _ctx.isSuccessBookingTab })),
        onOpened: _ctx.onOpenedAdvancedFilter,
        onReset: _cache[2] || (_cache[2] = 
          (isFetch) => _ctx.onResetAdvancedFilter(isFetch, _ctx.isSuccessBookingTab)
        ),
        ref: "advancedFilter",
        title: "Filter"
      }, null, 8, ["model-value", "customPlaceholder", "titleTypeCustom", "customTitlePlaceholderCityDestination", "customTitlePlaceholderAirportCode", "customTypeList", "onOpened"]),
      _createVNode(_component_time_range_picker, {
        startDate: _ctx.periodeStart,
        endDate: _ctx.periodeEnd,
        onSelect: _ctx.setPeriode,
        default: "custom",
        placeholder: "Pilih tanggal",
        ref: "dateRange",
        customClass: "border border-gray-lp-400 rounded-lg",
        customBackground: "bg-white",
        customPaddingIcon: "px-3 py-2 border-none",
        customPaddingField: "p-2 border-l-0 border-none",
        customIcon: "calendar-outlined"
      }, null, 8, ["startDate", "endDate", "onSelect"]),
      (_ctx.hubIdOptions.length > 0)
        ? (_openBlock(), _createBlock(_component_MultipleSelect, {
            key: 1,
            modelValue: _ctx.hubIdSelected,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.hubIdSelected = $event)),
            options: _ctx.hubIdOptions,
            onChange: _ctx.onChangeHubIdSelected,
            onClear: _ctx.onChangeHubIdSelected
          }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.bookingType === 'success')
      ? (_openBlock(), _createBlock(_component_LpButton, {
          key: 0,
          outline: "",
          iconV2: "",
          iconLeft: "download-new",
          "text-color": "red-lp-100",
          title: "Buat daftar kargo",
          onClick: _cache[4] || (_cache[4] = () => (_ctx.openDownloadListCargo = true))
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "actions", { onDownload: _ctx.onDownload }, () => [
      _createVNode(_component_ModalDownloadListCargo, {
        modelValue: _ctx.openDownloadListCargo,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDownloadListCargo = $event))
      }, null, 8, ["modelValue"])
    ])
  ], 2))
}